module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scanCode"
  }, [_c('i', {
    class: {
      'web-icon-mingpiansaomiao': true, 'gray': _vm.slectProBtn, 'blue': !_vm.slectProBtn
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": _vm.slectProBtn,
      "placeholder": "扫码录入条码"
    },
    on: {
      "change": _vm.getBarcode
    },
    model: {
      value: (_vm.barcode),
      callback: function($$v) {
        _vm.barcode = $$v
      },
      expression: "barcode"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-564cb98e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/scan-code.vue
// module id = 1278
// module chunks = 82